import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "settings-home" }
const _hoisted_2 = { class: "settings-home__card-list" }

import SettingsHomeCard from '@/settingsModule/components/SettingsHomeCard.vue';
import SettingsPageTitle from '@/settingsModule/components/SettingsPageTitle.vue';
import { i18n } from '@/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'SettingsHomePage',
  setup(__props) {

const t = i18n.t;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(SettingsPageTitle, {
      label: _unref(t)('設定')
    }, null, 8, ["label"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SettingsHomeCard, {
        to: "/settings/templates/order",
        title: _unref(t)('書式・帳票'),
        description: _unref(t)('発注書や帳票の出力書式を管理'),
        features: [_unref(t)('発注出力形式登録・編集')]
      }, null, 8, ["title", "description", "features"]),
      _createVNode(SettingsHomeCard, {
        to: "/settings/logic",
        title: _unref(t)('発注・計算ロジック'),
        description: _unref(t)('発注作成と計算の条件設定など'),
        features: [_unref(t)('発注作成条件'), _unref(t)('内示計算設定')]
      }, null, 8, ["title", "description", "features"]),
      _createVNode(SettingsHomeCard, {
        to: "/settings/format",
        title: _unref(t)('出力日付フォーマット'),
        description: _unref(t)('出力時の日付表示形式を設定'),
        features: [_unref(t)('日付フォーマット選択')]
      }, null, 8, ["title", "description", "features"])
    ])
  ]))
}
}

})